import {useEffect} from "react";

const PaymentFail = () => {
    useEffect(() => {
        localStorage.removeItem("CartItems");
    }, []);

    return (
        <div>
            <div className="flex items-center justify-center">
                <h1 className="p-[10%] text-[1rem] lg:text-[2rem] font-bold tracking-wide text-headingColor text-center">
                    Не удалось оформить заказ.
                </h1>
            </div>
            <div className="flex items-center justify-center">
                <h1 className="p-[10%] text-[1rem] lg:text-[2rem] font-bold tracking-wide text-headingColor text-center">
                    Проблема с оплатой, попробуйте позже.
                </h1>
            </div>
        </div>
    );
}

export default PaymentFail;